import { authConfig } from "../apiConfig";



export const get_designation_with_out_pagination = async () => {
  try {
    const response = await authConfig.post(`getdestinationList`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_designation_with_pagination = async (data) => {
  try {
    const response = await authConfig.post(`getdestinationList`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_designation_by_id = async (data) => {
  try {
    const response = await authConfig.post(`designationViewByid`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const designation_creation = async (data) => {
  try {
    const response = await authConfig.post(`createDesignation`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const designation_update = async (data) => {
  try {
    const response = await authConfig.post(`upadteDesigantion`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const designation_deletion = async (data) => {
  try {
    const response = await authConfig.post(`destinationDelete`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};